module.exports = __webpack_public_path__ + "img/web-bg.6341c1b1.png";